import React from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';

// Slide 1 — language-specific campaign
import s1EnWeb    from '../../assets/site-assets/slider/desktop/02_campaign-EN.webp';
import s1ArWeb    from '../../assets/site-assets/slider/desktop/02_campaign-AR.webp';
import s1EnMobile from '../../assets/site-assets/slider/mobile/00_campaign-EN.webp';
import s1ArMobile from '../../assets/site-assets/slider/mobile/00_campaign-AR.webp';

// Slides 2–5 — same image for both languages
import s2Web    from '../../assets/site-assets/slider/desktop/beach.webp';
import s2Mobile from '../../assets/site-assets/slider/mobile/01.webp';
import s3Web    from '../../assets/site-assets/slider/desktop/man.webp';
import s3Mobile from '../../assets/site-assets/slider/mobile/02.webp';
import s4Web    from '../../assets/site-assets/slider/desktop/skate.webp';
import s4Mobile from '../../assets/site-assets/slider/mobile/03.webp';
import s5Web    from '../../assets/site-assets/slider/desktop/wheelchair.webp';
import s5Mobile from '../../assets/site-assets/slider/mobile/04.webp';

import { ReactComponent as SliderVector } from '../../assets/site-assets/home/slider-vector.svg';
import { ReactComponent as SliderStar }   from '../../assets/site-assets/home/slider-star.svg';

import './HeroSlider.scss';

const slides = [
  { en: { web: s1EnWeb, mobile: s1EnMobile }, ar: { web: s1ArWeb, mobile: s1ArMobile } },
  { en: { web: s2Web,  mobile: s2Mobile  },   ar: { web: s2Web,  mobile: s2Mobile  } },
  { en: { web: s3Web,  mobile: s3Mobile  },   ar: { web: s3Web,  mobile: s3Mobile  } },
  { en: { web: s4Web,  mobile: s4Mobile  },   ar: { web: s4Web,  mobile: s4Mobile  } },
  { en: { web: s5Web,  mobile: s5Mobile  },   ar: { web: s5Web,  mobile: s5Mobile  } },
];

const HeroSlider = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language === 'ar' ? 'ar' : 'en';

  return (
    <section className="hero-slider">
      <button className="hero-slider__arrow hero-slider__arrow--prev" aria-label={t('heroSlider.previousSlide')}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={i18n.language === 'ar' ? { transform: 'scaleX(-1)' } : undefined}>
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>
      <button className="hero-slider__arrow hero-slider__arrow--next" aria-label={t('heroSlider.nextSlide')}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={i18n.language === 'ar' ? { transform: 'scaleX(-1)' } : undefined}>
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>

      <div className="hero-slider__pagination" />

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        loop
        autoplay={{ delay: 5500, disableOnInteraction: false }}
        speed={750}
        navigation={{
          prevEl: '.hero-slider__arrow--prev',
          nextEl: '.hero-slider__arrow--next',
        }}
        pagination={{
          el: '.hero-slider__pagination',
          clickable: true,
          bulletClass: 'hero-slider__bullet',
          bulletActiveClass: 'hero-slider__bullet--active',
        }}
        key={i18n.language}
        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
        className="hero-slider__swiper"
      >
        {slides.map((slide, idx) => (
          <SwiperSlide key={idx}>
            <div className="hero-slider__slide">
              <picture>
                <source media="(max-width: 768px)" srcSet={slide[lang].mobile} />
                <img src={slide[lang].web} alt={t(`heroSlider.slides.${idx}.alt`)} />
              </picture>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="hero-slider__float hero-slider__float--star">
        <SliderStar />
      </div>
      <div className="hero-slider__float hero-slider__float--vector">
        <SliderVector />
      </div>
    </section>
  );
};

export default HeroSlider;
